import { useRouter } from 'next/router'
import { FC, useContext } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { AuthContext } from '../../../../contexts/auth'
import { INavItem } from '../../../types'
import InnerNav from './InnerNav'

const PersonalInnerNav: FC = () => {
  const { asPath } = useRouter()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const { inited, user, logout } = useContext(AuthContext)

  const items: INavItem[] = [
    {
      code: 'personal',
      title: 'личные данные',
      href: '/personal',
      selected: asPath === '/personal',
    },
    {
      code: 'history',
      title: 'история заказов',
      href: '/history',
      selected: asPath === '/history',
    },
    {
      code: 'favorites',
      title: 'избранное',
      href: '/favorites',
      selected: asPath === '/favorites',
    },
    {
      code: 'exit',
      title: 'выход',
      onClick: async () => {
        if (!inited) {
          return
        }
        const token = await executeRecaptcha('logout')
        await logout({
          token,
        })
      },
    },
  ]

  if (!user) {
    return null
  }

  return <InnerNav items={items} />
}

export default PersonalInnerNav
